import styled from 'styled-components/macro';

import { chatUI } from 'styles/featureColors/chatUIColors';

export const ChatUIContainer = styled.div`
  display: block;
  padding: 0px;
  border-bottom: 1px solid #e1e6f2;
  background-color: ${chatUI.content.background};
  ${(props) => `height: ${props.height}`};
`;

export const ChatUIContent = styled.div`
  height: 100px;
  background-color: ${chatUI.content.background};
`;

export const ActionButton = styled.button`
  border: none;
  background-color: ${chatUI.buttons.default};
  color: white;
  padding: 5px;
  outline: none;
  cursor: pointer;
  border-radius: 3px;
  font: normal 11px/17px Roboto;
  width: 70px;
  height: 26px;
`;
